import {
  EMPTY_VALUE_PLACEHOLDER,
  formatAttributeDataValue
} from '@utils/attribute-data-formatter'

export const prepareProductCardFieldsData = (
  attrConfig,
  productData,
  allAttributesFlattenObject,
  t
) => {
  const fields = []
  if (attrConfig?.length && productData) {
    attrConfig.forEach(item => {
      const { attributeId, showLabel, hasDoubleSpace, displayType, caseType } = item
      const { labelKey, displayName } = allAttributesFlattenObject[attributeId] || {}
      const formattedValue: any =
        formatAttributeDataValue(
          productData,
          attributeId,
          allAttributesFlattenObject[attributeId]
        ) || {}

      fields.push({
        attributeId: attributeId,
        value: formattedValue?.value || EMPTY_VALUE_PLACEHOLDER,
        valueType: formattedValue?.type || '',
        showLabel,
        displayType,
        caseType,
        hasDoubleSpace,
        label: t ? t(labelKey, displayName) : displayName
      })
    })
  }
  return fields
}
